module.exports = __webpack_public_path__ + "img/parenti_smartbook.a92f84ef.png";